import {oauth, oauth_token} from '../api/oauth';
import {store} from '../store';

export function attemptLogIn(id_token) {
  return new Promise((resolve, reject) => {
    oauth(id_token).then(res => res.data).then(data => {
      if (!data.ok) {
        alert(`Failed: ${data.err}`);
        reject(`${data.err}`);
      }
      store.commit('handleOauthLoginResponse', data);
      resolve();
    }).catch((err) => {
      alert(`Server error: ${err}`);
      reject();
    })
  });
}


// WEBPACK FOOTER //
// ./src/util/auth.js